import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { useTranslation } from 'react-i18next';
import { UserOptions } from '../../types/chat';

interface InstructionsDialogProps {
  isOpen: boolean;
  closeModal: () => void;
  userOptions?: UserOptions | null;
}

export default function InstructionsDialog({ isOpen, closeModal, userOptions }: InstructionsDialogProps) {
  const { t } = useTranslation();
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-10 overflow-y-auto"
        onClose={closeModal}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
        </Transition.Child>

        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <div className="flex items-center justify-center min-h-screen">
            <div className="bg-white rounded-lg overflow-hidden shadow-xl max-w-lg w-full p-6">
              <Dialog.Title className="text-lg font-medium text-gray-900">
                {t('instructions.title')}
              </Dialog.Title>
              <div className="mt-2 text-sm text-gray-500">
                <ul className="list-disc pl-5 mt-2">
                  <li>{t('instructions.list.item1')}</li>
                  <li>{t('instructions.list.item2')}</li>
                  <li>{t('instructions.list.item3')}</li>
                  <li>{t('instructions.list.item4')}</li>
                  <li>{t('instructions.list.item5')}</li>
                </ul>
              </div>
              <div className="mt-4 text-center">
                <button
                  type="button"
                  className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-blue-500 border border-transparent rounded-md hover:bg-blue-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                  onClick={closeModal}
                >
                  {t('common.accept')}
                </button>
              </div>
            </div>
          </div>
        </Transition.Child>
      </Dialog>
    </Transition>
  );
}
